import { Radio, Space, Typography } from 'antd'
import type { RadioChangeEvent } from 'antd'
import { Search, BarChart3, CheckCircle2, FileText, FileEdit, GitBranch } from 'lucide-react'
import { useUIStore } from '@/store/uiStore'
import { SCENARIOS } from '@/config/constants'
import { t } from '@/config/translations'

const { Text } = Typography

const SCENARIO_CONFIG = {
  default: { icon: Search, key: 'scenario_default' },
  impact_analysis: { icon: BarChart3, key: 'scenario_impact_analysis' },
  requirements_validation: { icon: CheckCircle2, key: 'scenario_requirements_validation' },
  code_documentation: { icon: FileText, key: 'scenario_code_documentation' },
  template_generation: { icon: FileEdit, key: 'scenario_template_generation' },
  mermaid_generation: { icon: GitBranch, key: 'scenario_mermaid_generation' },
} as const

export function ScenarioSelector() {
  const { selectedScenario, setSelectedScenario } = useUIStore()

  const handleChange = (e: RadioChangeEvent) => {
    setSelectedScenario(e.target.value as (typeof SCENARIOS)[number])
  }

  return (
    <div style={{ padding: '16px', borderTop: '1px solid #f0f0f0' }}>
      <Space vertical style={{ width: '100%' }} size={12}>
        {/* Label */}
        <Text strong>{t('scenario_label')}</Text>

        {/* Scenario Radio Group */}
        <Radio.Group value={selectedScenario} onChange={handleChange} style={{ width: '100%' }}>
          <Space vertical style={{ width: '100%' }} size={8}>
            {SCENARIOS.map((scenario) => {
              const config = SCENARIO_CONFIG[scenario]
              const label = t(config.key as never)

              return (
                <Radio key={scenario} value={scenario} style={{ width: '100%' }}>
                  {label}
                </Radio>
              )
            })}
          </Space>
        </Radio.Group>
      </Space>
    </div>
  )
}
